import React from "react"
import { SyncSummary } from "./SyncSummary"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"
import { useBandEditForm } from "./BandEditFormContext"

interface BandcampProps {
  band: Band
}

export const Bandcamp: React.FC<BandcampProps> = ({ band }) => {
  const { form } = useBandEditForm()
  const bandcampUrl = form.watch("bandcamp_url")

  const fieldData = {
    field: "bandcamp_url",
    serviceClass: "BandcampService",
    name: "bandcamp",
    label: "Your Bandcamp URL",
    placeholder: "Bandcamp URL",
    notes:
      "Filling out your bandcamp url means that you allow us to display and stream all of your bandcamp music here on bandNada. Your url should look like: https://blackmothsuperrainbow.bandcamp.com/",
    required: false,
  }

  return (
    <>
      <EditBandFormField type="text" fieldData={fieldData} />
      <SyncSummary fieldData={fieldData} bandId={band.id} value={bandcampUrl} />
    </>
  )
}
